import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
}))
